const $ = require('jquery');
window.$ = window.jQuery = $;

require('./inter');

require('legacy-bootstrap');
require('legacy-bootstrap/dist/css/bootstrap.css');
require('../order_forms/css/one-trust.css');
